<div class="reset-container">

  @if(!resetPassword) {
    <div class="reset-form">
      <div class="reset-form-title">RESET PSWRD</div>
      <form [formGroup]="resetForm" class="reset-form-container" (ngSubmit)="forgotPassword()">
        <span class="reset-form-container-label">Email</span>
        <input 
          class="reset-form-container-input" 
          type="email" 
          formControlName="email"
          [attr.aria-label]="'Email input'"
          placeholder="Enter your email">
        
        @if(resetForm.get('email')?.touched && resetForm.get('email')?.errors?.['required']) {
          <span class="reset-form-container-error">Email is required</span>
        }
        @if(resetForm.get('email')?.touched && resetForm.get('email')?.errors?.['email']) {
          <span class="reset-form-container-error">Please enter a valid email</span>
        }

        <div class="reset-form-container-button-container">
          <button 
            type="submit"
            [disabled]="resetForm.invalid || isLoading"
            [ngClass]="{'disabled': resetForm.invalid || isLoading}"
            class="reset-form-container-button red-button">
            @if(isLoading) {
              <span class="loading-spinner"></span>
            } @else {
              RESET PASSWORD
            }
          </button>

          <button 
            type="button"
            class="reset-form-container-button dark-button" 
            [routerLink]="['/login']">
            LOGIN
          </button>
        </div>
      </form>
    </div>
  } 
  @if(emailSent) {

    <div class="reset-form">
      <div class="reset-sent-container">
        <div class="reset-sent-container-image" alt="reset-sent"></div>
        <h1 class="reset-sent-container-title">SENT</h1>
  
        <button 
          type="button"
          class="reset-form-container-button dark-button" 
          (click)="goToDomain()"
          [disabled]="!emailDomain">
          CHECK YOUR INBOX ON {{emailDomain | uppercase}}
        </button>
      </div>
    </div>
  }
  @if(emailClicked) {
    <div class="reset-form">
      <div class="reset-form-title">RESET PSWRD</div>
      <form [formGroup]="passwordResetForm" class="reset-form-container" (ngSubmit)="resetUserPassword()">
        <span class="reset-form-container-label">New Password</span>
        <input 
          class="reset-form-container-input" 
          type="password" 
          formControlName="password"
          [attr.aria-label]="'New password input'"
          placeholder="Enter new password">
        
        @if(passwordResetForm.get('password')?.touched && passwordResetForm.get('password')?.errors?.['required']) {
          <span class="reset-form-container-error">Password is required</span>
        }
        @if(passwordResetForm.get('password')?.touched && passwordResetForm.get('password')?.errors?.['minlength']) {
          <span class="reset-form-container-error">Minimum {{passwordMinLength}} characters</span>
        }

        <span class="reset-form-container-label">Confirm Password</span>
        <input 
          class="reset-form-container-input" 
          type="password" 
          formControlName="confirmPassword"
          [attr.aria-label]="'Confirm password input'"
          placeholder="Confirm new password">
        
        @if(passwordResetForm.get('confirmPassword')?.touched && passwordResetForm.get('confirmPassword')?.errors?.['required']) {
          <span class="reset-form-container-error">Please confirm your password</span>
        }
        @if(passwordResetForm.get('confirmPassword')?.touched && passwordResetForm.get('confirmPassword')?.errors?.['minlength']) {
          <span class="reset-form-container-error">Minimum {{passwordMinLength}} characters</span>
        }

        @if(passwordResetForm.errors?.['passwordMismatch'] && 
            passwordResetForm.get('confirmPassword')?.touched && 
            passwordResetForm.get('password')?.touched) {
          <span class="reset-form-container-error">Passwords do not match</span>
        }

        <button 
          type="submit"
          [disabled]="passwordResetForm.invalid || isLoading"
          [ngClass]="{'disabled': passwordResetForm.invalid || isLoading}"
          class="reset-form-container-button red-button">
          @if(isLoading) {
            <span class="loading-spinner"></span>
          } @else {
            UPDATE PASSWORD
          }
        </button>
      </form>
    </div>
  }
  @if(resetSuccess) {
    <div class="reset-sent-container">
      <div class="success-image" alt="reset-success"></div>
      <h1 class="reset-sent-container-title">GREAT</h1>

      <button 
        type="button"
        class="reset-form-container-button dark-button" 
        routerLink="/login">
        LOGIN NOW
      </button>
    </div>
  }
</div>